import { render, staticRenderFns } from "./ColumnIndex.vue?vue&type=template&id=ca4fb270&scoped=true"
import script from "./ColumnIndex.vue?vue&type=script&lang=js"
export * from "./ColumnIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4fb270",
  null
  
)

export default component.exports